export function shouldShowContextSwitcher(organizationCount: number, projectCount: number): boolean {
  return organizationCount > 1 || projectCount > 1;
}

export function contextDisplayLabel(organizationName: string | null, projectName: string | null): string {
  if (organizationName && projectName) return `${organizationName} / ${projectName}`;
  return organizationName ?? projectName ?? 'Working context';
}
